<template>
  <div>
    <h1 class="mb-4">Active CNA Report</h1>

    <b-row class="mb-2">
      <b-col>
        <b-button type="button" variant="primary" @click="exportToZip" v-if="!isLoading">Export Report</b-button>
      </b-col>
    </b-row>
    <b-row role="alert">
      <b-col>
        <div class="sr-only hidden" v-if="isLoading">Loading, Please Wait...</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table hover small responsive show-empty class="sr-caption"
                 aria-live="polite"
                 :fields="fields"
                 :items="records"
                 :busy="isLoading"
                 label-sort-asc=""
                 label-sort-desc=""
                 :current-page="currentPage"
                 :per-page="perPage"
                 caption="CNA Report table.  To sort the data in this table by a specific column,
                    go to the appropriate column header cell and use enter to sort the data ascending.
                    Use enter again to sort descending.">
          <template v-slot:empty="scope">
            <p>No results found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>

        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="fill"
                size="sm"
                class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="8">
        <b-form-group
                label="Per page"
                label-size="sm"
                label-for="perPageSelect"
        >
          <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { excelService } from '@/mixins/excelService.js'

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  });

export default {
  data: () => ({
    fields: [
      {key: 'certificateNumber', sortable: true, label: 'Certificate Number'},
      {key: 'firstName', sortable: true, label: 'First Name'},
      {key: 'lastName', sortable: true, label: 'Last Name'},
      {key: 'dateCertified', sortable: true, label: 'Date Certified'},
      {key: 'lastModifyDate', sortable: true, label: 'Last Modify Date'},
      {key: 'phone', sortable: true, label: 'Phone Number'},
      {key: 'address', sortable: true, label: 'Address'},
      {key: 'city', sortable: true, label: 'City'},
      {key: 'state', sortable: true, label: 'State'},
      {key: 'postalCode', sortable: true, label: 'ZIP Code'},
      {key: 'email', sortable: true, label: 'Email'},
      {key: 'employer', sortable: true, label: 'Employer'},
    ],
    isLoading: false,
    records: [],
    perPage: 10,
    currentPage: 1,
    totalRows: 1,
    pageOptions: [5, 10, 15, 20],
  }),

  created () {
    document.title = "Active CNA Report - NAR"
    this.fetchCnas()
  },

  methods: {
    fetchCnas() {
        this.isLoading = true;
        let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/certificate/active-cna`
        axios.get(fullUrl)
          .then(response => {
              this.records = response.data;
              this.isLoading = false;
              this.totalRows = this.records.length
              this.currentPage = 1
          })
    },
    exportToZip() {
      excelService.exportAsExcelFile(this.records, [['Certificate Number', 'First Name', 'Last Name', 'Date Certified', 'Last Modify Date', 'Phone Number', 'Address', 'City', 'State', 'ZIP Code', 'Email', 'Employer']], "Active CNA Report")
    }
  },
}
</script>